import validateConfig from 'hb-react/shared/utils/validateAppConfig';

const requiredConfigKeys = ['getDataUrl'];
const optionalConfigKeys = [];

export const validate = (config) =>
  validateConfig({
    config,
    appName: 'UpdateUserDataApp',
    requiredConfigKeys,
    optionalConfigKeys,
  });
